import { MOBILE_BREAKPOINT, HEADER_HEIGHT } from '../../SearchApp/constants';

export const getSearchPageHeaderOffset = (cookieHeaderOffset) => {
    let offset = HEADER_HEIGHT;

    if (typeof window === 'object') {
        const mediaQuery = window.matchMedia(
            `(min-width: ${MOBILE_BREAKPOINT})`,
        );

        if (mediaQuery.matches) {
            offset = cookieHeaderOffset
                ? HEADER_HEIGHT + cookieHeaderOffset
                : HEADER_HEIGHT;
        }
    }

    return offset;
};
